import { COMPETITORS } from '../compare/competitors.js'

export const PATH = '/break-reminder-app'

export const TABLE_APPS = ['keybreak', 'stretchly', 'workrave', 'timeOut', 'restier', 'breakTimer']

// Column order for the product page. Labels and cell prose come from the
// locale files; competitors.js holds the facts and the source URLs.
export const TABLE_COLUMNS = [
    { key: 'guidedStretches' },
    { key: 'humanDemonstration' },
    { key: 'focusAreas' },
    { key: 'injuryAware' },
    { key: 'freeTier' },
    { key: 'platforms' },
]

export const DIFFERENCES = [
    {
        id: 'stretchly',
        name: 'Stretchly',
        sources: [COMPETITORS.stretchly.sources.guidedStretches],
    },
    {
        id: 'workrave',
        name: 'Workrave',
        sources: [COMPETITORS.workrave.sources.platforms, COMPETITORS.workrave.sources.guidedStretches],
    },
    {
        id: 'timeOut',
        name: 'Time Out',
        sources: [COMPETITORS.timeOut.sources.guidedStretches],
    },
    {
        id: 'restier',
        name: 'Restier',
        sources: [COMPETITORS.restier.sources.freeTier, COMPETITORS.restier.sources.guidedStretches],
    },
]

